import api from "../../services/api";
import {
  CREATE_ARTICLE_REQUEST,
  GET_ARTICLE_BY_CHAPTER_ID_FAILURE,
  GET_ARTICLE_BY_CHAPTER_ID_REQUEST,
  GET_ARTICLE_BY_CHAPTER_ID_SUCCESS,
  RESET_ARTICLE_VARIABLES,
} from "./ActionType";

const createArticleRequest = () => ({
  type: CREATE_ARTICLE_REQUEST,
});

const createArticleSuccess = (payload) => ({
  type: "CREATE_ARTICLE_SUCCESS",
  payload,
});

const createArticleFailure = (payload) => ({
  type: "CREATE_ARTICLE_FAILURE",
  payload,
});

export const createArticle = (chapterId, articleData) => async (dispatch) => {
  dispatch(createArticleRequest());
  try {
    // Assuming you have an API service to handle the request
    const response = await api.post(
      `/chapters/${chapterId}/articles`,
      articleData
    );
    dispatch(createArticleSuccess(response.data));
  } catch (error) {
    dispatch(createArticleFailure(error.response.data));
  }
};

const getArticleByChapterIdRequest = () => ({
  type: GET_ARTICLE_BY_CHAPTER_ID_REQUEST,
});

const getArticleByChapterIdSuccess = (payload) => ({
  type: GET_ARTICLE_BY_CHAPTER_ID_SUCCESS,
  payload,
});

const getArticleByChapterIdFailure = (payload) => ({
  type: GET_ARTICLE_BY_CHAPTER_ID_FAILURE,
  payload,
});

export const getArticleByChapterId = (chapterId) => async (dispatch) => {
  dispatch(getArticleByChapterIdRequest());
  try {
    const response = await api.get(`/chapters/${chapterId}/articles`);
    dispatch(getArticleByChapterIdSuccess(response.data));
  } catch (error) {
    dispatch(getArticleByChapterIdFailure(error.response.data));
  }
};

export const resetVariables = () => ({
  type: RESET_ARTICLE_VARIABLES,
});
